import React, { Fragment } from "react";
import { Link, graphql } from "gatsby";
import PropTypes from "prop-types";
import { css } from "styled-components";
import { Flex } from "rebass";
import { BigLetters } from "../components/Text";
import SEO from "../components/seo";

/**
 * Shuffles array in place. ES6 version
 * @param {Array} a items An array containing the items.
 */
function shuffle(a) {
  for (let i = a.length - 1; i > 0; i--) {
    // eslint-disable-line
    const j = Math.floor(Math.random() * (i + 1));
    [a[i], a[j]] = [a[j], a[i]];
  }
  return a;
}

const IndexPage = ({ data: { list = {} } }) => {
  const { node: { artists = [] } = {} } = list.edges[0] || {};

  return (
    <Fragment>
      <SEO
        title="PLX TJÄRÖ 2021 Artister"
        keywords={[`PLX TJÄRÖ`, `festival`, `artister`]}
      />
      <Flex
        flexDirection="column"
        justifyContent="flex-end"
        as="ul"
        px={[3, 3, 4]}
        pt="60px"
        pb="180px"
        my="0"
        mx={[-3, -3, -4]}
        bg={[
          "rgba(0, 0, 0, 0.9)",
          "rgba(0, 0, 0, 0.9)",
          "rgba(0, 0, 0, 0.9)",
          "rgba(0, 0, 0, 0.5)"
        ]}
        css={css`
          min-height: calc(100vh - 160px);
          list-style: none;
          position: relative;
        `}
      >
        {shuffle(artists).map(node => (
          <li key={node.id}>
            <Link to={`/artist/${node.slug}`}>
              <BigLetters fontSize={[6, 6, 6, 5, 5, "60px"]}>
                {node.name}
              </BigLetters>
            </Link>
          </li>
        ))}
      </Flex>
    </Fragment>
  );
};

IndexPage.propTypes = {
  data: PropTypes.object.isRequired
};

export const query = graphql`
  {
    list: allContentfulArtistsCollection {
      edges {
        node {
          artists {
            id
            name
            slug
          }
        }
      }
    }
  }
`;

export default IndexPage;
